// extracted by mini-css-extract-plugin
module.exports = {"paralellPublishing":"styles_paralellPublishing__GHW9C"};